export const tagColors: string[] = [
	"#00AA00", // green
	"#0000FF", // blue
	"#FF0000", // red
	"#9C27B0", // purple
	"#FFA500", // orange
	"#397234", // forest green
	"#283F23", // dark olive
	"#3F2617", // dark brown
	"#0B0F08", // charcoal black
	"#889c2dff", // olive green
	"#B78449", // tan brown
	"#5D9F96", // teal
	"#1d5e74ff", // dark teal
	"#FA7305", // bright orange
	"#072684", // navy blue
	"#269473ff", // emerald green
	"#5d74b9ff", // slate blue
	"#0C8EF4", // sky blue
	"#8d481cff", // rust brown
	"#2B384C", // dark slate
];

let availableColors: string[] = [...tagColors];
let lastColor: string | null = null;

export const getRandomColor = (): string => {
	if (availableColors.length === 0) {
		availableColors = [...tagColors];
		if (lastColor && availableColors.length > 1) {
			availableColors.splice(availableColors.indexOf(lastColor), 1);
		}
	}

	const randomIndex = Math.floor(Math.random() * availableColors.length);
	const color = availableColors[randomIndex];
	availableColors.splice(randomIndex, 1);
	lastColor = color;
	return color;
};
